import React, { Component } from "react";
import { AutoComplete, Form, Input, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { CUSTOMER_CODE } from "../../../../common/utils/static-data";
import { apiCustomer } from "../../../../api/api-customer";
import { UserType } from "../user-type/user-type";
import { CardType } from "../card-type/card-type";
import { checkUserType } from "../user-event";

const antIcon = <LoadingOutlined style={{ fontSize: 22 }} spin />;
const { Option } = AutoComplete;

export class AddNewCustomer extends Component {
  state = {
    customerOptions: [],
    customer: {},
  };

  timeout = null;
  currentValue = "";
  totalPage = 1;
  page = 1;

  onSearch = (data) => {
    var self = this;
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
    this.page = 1;
    if (data.trim() !== this.currentValue.trim()) {
      if (this.state.customer) {
        this.setState({ customer: {} });
      }
    }
    this.currentValue = data;
    this.onChangeFormValues({
      name: data.toUpperCase(),
    });
    if (!data) {
      this.setState({
        customerOptions: [],
      });
      return;
    }

    async function searchData() {
      let func = apiCustomer.customerSuggest;
      let filters = {
        name: `%${data.trim()}%`,
        customer_type: {
          code: CUSTOMER_CODE.enterprise,
        },
      };
      try {
        const result = await func(filters, 1);
        if (result.status === "success") {
          self.totalPage = result.data.total_pages;
          if (self.currentValue !== data) {
            return;
          }
          self.setState({
            customerOptions: result.data.content.map((suggestion) => {
              const { customer_type } = suggestion;
              return {
                ...suggestion,
                value: `${suggestion.name} - ${
                  customer_type.code === CUSTOMER_CODE.enterprise
                    ? ""
                    : suggestion.phone_number
                }`,
              };
            }),
          });
        }
      } catch (error) {}
    }

    this.timeout = setTimeout(searchData, 300);
  };

  onSelect = (item) => {
    const { data } = item;
    const { customer_type } = data;
    const { setEnterprise } = this.props;
    this.currentValue = data.name;
    this.page = 1;
    this.totalPage = 1;
    setEnterprise(customer_type.code === CUSTOMER_CODE.enterprise);
    this.setState({ customer: data, customerOptions: [data] });
    let values = {
      name: data.name,
      customer_type: customer_type.code,
      address: data.address,
      tax_code: data.tax_code,
      bank_account_holder: data.bank_account_holder,
      bank_name: data.bank_name,
      bank_account_number: data.bank_account_number,
    };
    if (customer_type.code === CUSTOMER_CODE.enterprise) {
      this.onChangeFormValues(values);
    } else {
      this.onChangeFormValues({
        ...values,
        users: [],
        mobile: data.phone_number,
      });
    }
  };

  onChangeFormValues = (values) => {
    const { onChangeFormValues } = this.props;
    onChangeFormValues({ ...values });
  };

  loadMoreFunc = async () => {
    let func = apiCustomer.customerSuggest;
    const data = this.currentValue;
    let filters = {
      name: `%${data.trim()}%`,
      customer_type: {
        code: CUSTOMER_CODE.enterprise,
      },
    };
    try {
      this.setState({ isLoadMore: true });
      const result = await func(filters, this.page);

      if (result.status === "success") {
        this.totalPage = result.data.total_pages;
        this.setState(
          {
            customerOptions: this.state.customerOptions.concat(
              result.data.content.map((suggestion) => {
                const { customer_type } = suggestion;
                return {
                  ...suggestion,
                  value: `${suggestion.name} - ${
                    customer_type.code === CUSTOMER_CODE.enterprise
                      ? ""
                      : suggestion.phone_number
                  }`,
                };
              })
            ),
          },
          () => this.setState({ isLoadMore: false })
        );
      } else {
        this.setState({ isLoadMore: false });
      }
    } catch (error) {
      this.setState({ isLoadMore: false });
    }
  };

  suggestionRender = (data) => {
    let loadMore = false;
    loadMore = this.totalPage > this.page;

    const { isLoadMore } = this.state;

    return (
      <>
        {data.map((item) => {
          const { customer_type } = item;
          return (
            <Option
              data={item}
              style={styles.selectOptoption}
              key={item.customer_id}
              value={item.value}
            >
              <div style={styles.container}>
                <div style={styles.mainTitle}>{`${item.name}${
                  customer_type.code === CUSTOMER_CODE.enterprise
                    ? ""
                    : `-${item.phone_number}`
                }`}</div>
                <div style={styles.contract_contained}>
                  {customer_type.code === CUSTOMER_CODE.enterprise
                    ? `Khách hàng doanh nghiệp`
                    : `Khách hàng cá nhân`}
                </div>
              </div>
            </Option>
          );
        })}
        {data.length > 0 && loadMore && !isLoadMore && (
          <Option disabled={true} style={styles.loadmoreOption}>
            <div
              onClick={() => {
                this.page++;
                this.loadMoreFunc();
              }}
              style={styles.loadmore}
            >
              Loadmore
            </div>
          </Option>
        )}
        {isLoadMore && (
          <Option disabled={true} style={styles.loadmoreOption}>
            <div style={styles.loadmoreLoading}>
              <Spin indicator={antIcon} />
            </div>
          </Option>
        )}
      </>
    );
  };

  onChangeName = (data) => {
    this.onChangeFormValues({
      name: data.toUpperCase(),
    });
  };

  render() {
    const { customerOptions } = this.state;
    const {
      enterprise,
      setEnterprise,
      editable,
      editPage,
      isModal,
    } = this.props;
    return (
      <>
        <Form.Item
          wrapperCol={15}
          name={"name"}
          label={`* Tên khách hàng::`}
          rules={[
            {
              required: true,
              message: `Vui lòng nhập Tên khách hàng!`,
            },
            {
              max: 100,
              message: "Tên khách hàng vượt quá 100 ký tự!",
            },
          ]}
        >
          <AutoComplete
            placeholder="Tên khách hàng"
            disabled={!editable}
            getPopupContainer={(node) => {
              if (node) {
                return node.parentNode;
              }
              return document.body;
            }}
            ref={(ref) => (this.auto = ref)}
            defaultActiveFirstOption={false}
            onSearch={(data) =>
              editPage ? this.onChangeName(data) : this.onSearch(data)
            }
            onSelect={(data, option) => this.onSelect(option)}
            className="customer-name"
          >
            {this.suggestionRender(customerOptions)}
          </AutoComplete>
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          name="customer_type"
          label={`* Phân loại khách hàng::`}
        >
          <UserType
            disabled={editPage}
            setEnterprise={(value) => {
              setEnterprise(value);
              if (value) {
                this.onSearch(this.currentValue);
              }
              this.setState({ customer: {}, customerOptions: [] });
            }}
            onChangeFormValues={this.onChangeFormValues}
            validate={this.props.validate}
          />
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          name={"address"}
          label={`* Địa chỉ khách hàng::`}
          rules={[
            {
              required: true,
              message: `Vui lòng nhập Địa chỉ khách hàng!`,
            },
            {
              max: 255,
              message: "Địa chỉ khách hàng vượt quá 255 ký tự!",
            },
          ]}
        >
          <Input disabled={!editable} placeholder="Địa chỉ khách hàng" />
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          name={enterprise ? "tax_code" : "id_card"}
          label={enterprise ? "* Mã số thuế DN::" : "* Mã số cá nhân::"}
          //dependencies={['customer_type']}
          rules={[
            {
              required: true,
              message: enterprise
                ? "Vui lòng nhập Mã số thuế DN!"
                : "Vui lòng nhập Mã số cá nhân!",
            },
            {
              max: 100,
              message: enterprise
                ? "Mã số thuế vượt quá 100 ký tự!"
                : "Mã số cá nhân vượt quá 100 ký tự!",
            },
          ]}
        >
          <Input
            disabled={!editable}
            placeholder={enterprise ? "Mã số thuế DN" : "Mã số cá nhân"}
          />
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          name="card_type"
          label=" "
          className={enterprise ? "hidden" : ""}
        >
          <CardType
            disabled={!editable}
            onChangeFormValues={this.onChangeFormValues}
          />
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          name={"bank_account_holder"}
          label={`Tên chủ tài khoản::`}
          className="normalStyle"
          rules={
            [
              // checkUserType('Tên chủ tài khoản')
            ]
          }
        >
          <Input disabled={!editable} placeholder="Tên chủ tài khoản" />
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          className="normalStyle"
          name={"bank_name"}
          label={`Tên ngân hàng::`}
          rules={
            [
              // checkUserType('Tên ngân hàng')
            ]
          }
        >
          <Input disabled={!editable} placeholder="Tên ngân hàng" />
        </Form.Item>
        <Form.Item
          wrapperCol={15}
          className="normalStyle"
          name={"bank_account_number"}
          label={`Số tài khoản::`}
          rules={
            [
              // checkUserType('Số tài khoảng')
            ]
          }
        >
          <Input disabled={!editable} placeholder="Số tài khoản" />
        </Form.Item>
      </>
    );
  }
}

export const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    minHeight: 35,
  },
  contract_contained: {
    fontSize: "10px",
    color: "#f4bc2b",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
  },
  icon: {
    fontSize: "0.9em",
    marginRight: 3,
    color: "#f4bc2b",
  },
  mainTitle: {
    fontSize: "0.93em",
    color: "#000",
    fontWeight: "500",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
    //lineHeight: '10px'
  },

  selectOptoption: {
    borderBottom: "0.3px solid #d9d9d9",
    position: "relative",
  },
  loadmore: {
    color: "#3a7be2",
    position: "absolute",
    bottom: 0,
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    padding: "0px 10px",
    zIndex: 9999,
    marginBottom: "5px",
  },
  loadmoreOption: {
    padding: "0px 4px",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
  loadmoreLoading: {
    display: "flex",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    padding: "0px 10px",
    marginBottom: "5px",
    zIndex: 9999,
  },
};
